import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const saveFlyer = async (id, payload) => {
  if (id) {
    const { data } = await api.put(`/flyers/${id}`, payload);
    return data;
  }
  const { data } = await api.post(`/flyers`, payload);
  return data;
};

export const fetchFlyer = async (id) => {
  const { data } = await api.get(`/flyers/${id}`);
  return data;
};

export const listFlyers = async () => {
  const { data } = await api.get(`/flyers`);
  return data;
};

export const submitEnquiry = async (payload) => {
  const { data } = await api.post(`/enquiries`, payload);
  return data;
};
